import api from "./api";

export type DashboardWidgetType = "STAT" | "LIST" | "DONUT" | "TREND";

export interface DashboardStatWidget {
  type: "STAT";
  key: string;
  title: string;
  value: number;
}

export interface DashboardListWidget {
  type: "LIST";
  key: string;
  title: string;
  items: unknown[];
}

export interface DonutSegment {
  label: string;
  value: number;
  color: string;
}

export interface DonutStat {
  key: string;
  label: string;
  value: number;
  color: string;
  icon: string;
}

export interface TrendPoint {
  value: number;
  label: string;
}

export type TrendGranularity = "month" | "week" | "day";

export interface DashboardDonutWidget {
  type: "DONUT";
  key: string;
  title: string;
  total: number;
  centerLabel: string;
  segments: DonutSegment[];
  stats: DonutStat[];
}

export interface DashboardTrendWidget {
  type: "TREND";
  key: string;
  title: string;
  color: string;
  granularity?: TrendGranularity;
  series: Record<TrendGranularity, TrendPoint[]>;
  dates?: string[];
}

export type DashboardWidget =
  | DashboardStatWidget
  | DashboardListWidget
  | DashboardDonutWidget
  | DashboardTrendWidget;

export const getDashboard = async (): Promise<{ widgets: DashboardWidget[] }> => {
  const response = await api.get("/dashboard");
  const data = response.data?.data ?? response.data;
  const widgets = Array.isArray(data?.widgets) ? data.widgets : [];
  return { widgets };
};

export const getDashboardStats = async (): Promise<any> => {
  const response = await api.get("/dashboard/stats");
  return response.data;
};
